var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel panel-login" }, [
    _c("div", { staticClass: "row no-gutters icons justify-content-center" }, [
      _c("ul", { staticClass: "nav" }, [
        _c(
          "li",
          { staticClass: "nav-item icon mx-3" },
          [
            _c("router-link", { attrs: { to: { name: "portal.login" } } }, [
              _c("img", {
                attrs: {
                  src: require("../../../assets/images/icon-login.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Login")]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "nav-item icon" },
          [
            _c("router-link", { attrs: { to: { name: "portal.home" } } }, [
              _c("img", {
                attrs: {
                  src: require("../../../assets/images/icon-portal.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Portal")]),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm.modules()
      ? _c("div", { staticClass: "row no-gutters" }, [
          _c("div", { staticClass: "col-sm-12 modules" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row no-gutters" }, [
      _c("p", [
        _vm._v("Não se encontra registado na aplicaçãoou não efetuou o login."),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Por favor registe-se ou faça o login de modo a ter acesso personalizado às ocorrências reportadas por si."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }